import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationWrapper = ({ children }) => {
  const navigate = useNavigate();

  const navigationProps = {
    onWatchlistClick: () => navigate('/watchlist'),
    onHighLowClick: () => navigate('/highlow'),
    onMomentumClick: () => navigate('/momentum'),
    onRuleStrategyClick: () => navigate('/rule-strategy'),
    onIndexMoverClick: () => navigate('/index-mover'),
    onNetPositionClick: () => navigate('/net-position'),
    onDistributionClick: () => navigate('/distribution'),
    onSectorOverviewClick: () => navigate('/sector-overview'),
    onBulkDealsPageClick: () => navigate('/bulk-deals'),
    onFiiDiiClick: () => navigate('/fii-dii'),
    onNiftyRealtyClick: () => navigate('/nifty-realty'),
    onIntradayScanClick: () => navigate('/intraday-scan'),
    onMomentumRadarClick: () => navigate('/momentum-radar'),
    onHeatmapClick: () => navigate('/heatmap'),
    onOilMonitorClick: () => navigate('/oil-monitor'),
    onSIPCalculatorClick: () => navigate('/sip-calculator'),
    onSWPCalculatorClick: () => navigate('/swp-calculator'),
    onTradersDiaryClick: () => navigate('/traders-diary'),
    onProfileClick: () => navigate('/profile'),
    onBack: () => navigate(-1), // Go back in history
    onBackToDashboard: () => navigate('/dashboard'),
    onNiftyItClick: () => navigate('/nifty-it'),
    onSectorSelect: (sector) => {
      sessionStorage.setItem('selectedSector', sector);
      navigate('/sector-rotation');
    }
  };

  return React.cloneElement(children, navigationProps);
};

export default NavigationWrapper;
